import React from 'react'
import { M_Table } from 'src/M_Components'

const equipment = () => {
  return (
    <M_Table entityName={'equipment'} />
  )
}

export default equipment